/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './card_list';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "CardListService": {
                    "methods": {
                      "GetCardList": {
                        "requestType": ".squareup.bbfrontend.service.v1.GetCardListRequest",
                        "responseType": ".squareup.bbfrontend.service.v1.GetCardListResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CardListService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CardListService @ squareup/bbfrontend/v1/card_list_service.proto at 12:1
 */
export const CardListService = $root.lookupService('squareup.bbfrontend.service.v1.CardListService');